export default __webpack_public_path__ + "static/media/info-icon.adec4ec8.svg";